import st from "lib/utils/index";
import BaseDecorator from "./BaseDecorator";

@BaseDecorator.translates(["name"])
export default class ProductOrderFieldListOptionDecorator extends BaseDecorator {
  static build(data = {}) {
    return new this({
      uuid: st.generateUuid(),
      translations: [],
      ...data,
    });
  }

  display_name_with_price(field) {
    const price = this.display_price(field);
    return price ? `${this.name} (${price})` : this.name;
  }

  display_price(field) {
    if (!this.price || !this.price.value) {
      return;
    }
    const price = st.formatMoney(this.price);
    const label = field.price_label;
    return [price, label].filter((x) => !!x).join(" ");
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/ProductOrderFieldListOptionDecorator.js